// extracted by mini-css-extract-plugin
export default {"header":"layout-wallet_header__OVH0U","date-picker":"layout-wallet_date-picker__yMbsN","date-icon":"layout-wallet_date-icon__z5lho","content":"layout-wallet_content__r5M1f"};